<script>
    import { user_data, flow_steps } from './stores.js';
    import Router, {link, location, push, pop, replace} from 'svelte-spa-router';
    import { SvelteToast } from '@zerodevx/svelte-toast'
    // import {count} from "../stores.js";
    // import Iqtemplate from "./components/iqtemplate.svelte";
	import Landingpage from './landingpage.svelte';
	import IQ from './iqpage.svelte';
    import IQPD from './iqp_price_downpayment_page.svelte';
    import IQPT from './iqp_property_type_page.svelte';
    import IQPCSE from './iqp_credit_score_estimate_page.svelte';
    import IQPMV from './iqp_military_veteran_page.svelte';
    import IQRCL from './iqr_current_loan_page.svelte';
    import RT from './rate_table_page.svelte';

    import DF from './dfpage.svelte';
    import DFPS from './dfp_process_status_page.svelte';
    import DFPHT from './dfp_home_type_page.svelte';
    import DFPHTP from './dfp_home_type_purchasing_page.svelte';
    import DFPT from './dfp_property_type_page.svelte';
    import DFPL from './dfp_property_location_page.svelte';
    import DFPCSE from './dfp_credit_score_estimate_page.svelte';
    import DPFPD from './dfp_price_downpayment_page.svelte';
    import DPFMV from './dfp_military_veteran_page.svelte';
    import DPFCR from './dfp_current_realtor_page.svelte';
    import DPFAY from './dfp_about_yourself_page.svelte';
    import DPFTY from './dfp_thank_you_page.svelte';
    import DPFH from './dfp_how_can_we_help.svelte';
    import DPFPP from './dfp_when_planning_purchase.svelte';
    
    import DRFFG from './dfr_financing_goal_page.svelte';
    import DRFPA from './dfr_property_address_page.svelte';
    import DRFNPA from './dfr_new_property_address_page.svelte';
    import DRFHVE from './dfr_home_value_estimate_page.svelte';
    import DFRHT from './dfr_home_type_page.svelte';
    import DFRT from './dfr_property_type_page.svelte';
    import DCAA from './dfr_cashout_amount.svelte';
    import DDCA from './dfr_consolidation_amount.svelte';
    import DDPOM from './dfr_pay_off_mortgage.svelte';
    import RES from './real_estate_servicespage.svelte';
    import HIS from './homeowners_insurance_services_page.svelte';
    import TIS from './title_insurance_services_page.svelte';

    import HE100LA from './he_100_loan_amount.svelte';
    import HE100ECS from './he_100_estimated_credit_score.svelte';
    import HE100FTB from './he_100_first_time_buyer.svelte';
    import HE100CHT from './he_100_current_home_type.svelte';
    import HE100TY from './he_100_thank_you.svelte';
    // import HE100Q1 from './he_100_qualify1.svelte';
    // import HE100Q2 from './he_100_qualify2.svelte';
    import HE100Q from './he_100_qualify.svelte';
    import HE100CHO from './he_100_currrently_own_a_home.svelte';

    import {onMount} from "svelte";

    onMount(async () =>{
    });
    const routes = {
        '/': Landingpage,
        '/iq': IQ,
        '/iqp_price_downpayment': IQPD,
        '/iqp_property_type': IQPT,
        '/iqp_credit_score_estimate': IQPCSE,
        '/iqp_military_veteran': IQPMV,
        '/iqr_current_loan': IQRCL,
        '/rate_table': RT,

        '/df': DF,
        '/dfp_process_status': DFPS,
        '/dfp_home_type': DFPHT,
        '/dfp_property_type': DFPT,
        '/dfp_property_location': DFPL,
        '/dfp_credit_score_estimate': DFPCSE,
        '/dfp_price_downpayment': DPFPD,
        '/dfp_military_veteran': DPFMV,
        '/dfp_current_realtor': DPFCR,
        '/dfp_about_yourself': DPFAY,
        '/dfp_thank_you': DPFTY,
        '/dfp_how_can_we_help': DPFH,
        '/dfp_when_planning_purchase': DPFPP,
        '/dfr_financing_goal': DRFFG,
        '/dfr_property_address': DRFPA,
        '/dfr_new_property_address': DRFNPA,
        '/dfr_home_value_estimate': DRFHVE,
        '/dfr_home_type': DFRHT,
        '/dfr_home_type_purchasing': DFPHTP,
        '/dfr_property_type': DFRT,
        '/dfr_cashout_amount': DCAA,
        '/dfr_consolidation_amount': DDCA,
        '/dfr_pay_off_mortgage': DDPOM,
        '/real_estate_services': RES,
        '/homeowners_insurance_services_page': HIS,
        '/title_insurance_services_page': TIS,
        '/loan_amount': HE100LA,
        '/credit_score': HE100ECS,
        '/first_time_home_owner': HE100FTB,
        '/current_home_type': HE100CHT,
        '/thank_you': HE100TY,
        // '/qualify1': HE100Q1,
        // '/qualify2': HE100Q2,
        '/qualify': HE100Q,
        '/current_homeowner': HE100CHO,
        
        
    };
	// build flows here
	// link_items.forEach((ni) => {
    //     // routes[`/${ni}`] = eval(ni);
    //     routes[`/${ni[0]}`] = wrap({
    //         component: ni[1],
    //         userData: {id: ni[2]}
    //     });        
    // });

	function routeEvent(event) {
        console.log("doing a route thing");
        const event_details = event.detail;
console.log($user_data);
console.log($flow_steps);
		console.log(event_details);
        // if (typeof gtag !== "undefined"){

        //     document.title = `Get Home Faster | HomeEasy (${event_details.location})`;
        //     // gtag("config", "G-5EQFF1MW1W", {
        //     //     page_path: event_details.location
        //     // });
        //     gtag('set', 'page_path', event_details.location);
        //     gtag('event', 'page_view');

        //     }

    }
	

</script>

<SvelteToast />

<!-- modify depending on flow? -->
<Router {routes} on:routeLoaded={routeEvent}/>

<!-- <Iqtemplate /> -->

<style>

</style>